import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { GivingCampaignGroupPartnerDto } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'
import { Table, TableBody, TableProvider } from '@percent/lemonade'
import { GroupsTableRow } from './GroupsTableRow/GroupsTableRow'

export type GroupsTableProps = Readonly<{
  data: GivingCampaignGroupPartnerDto[]
  isLoading: boolean
  totalResults: number | null
}>

export function GroupsTable({ data, isLoading, totalResults }: GroupsTableProps) {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      { id: t('table.header.name'), props: { width: 'auto' } },
      { id: t('typography.campaigns'), props: { width: '10rem' } },
      { id: t('table.header.status'), props: { width: '10rem' } },
      { id: '', props: { width: '2.25rem' } }
    ],
    [t]
  )

  return (
    <TableProvider
      columns={columns}
      totalResults={totalResults}
      isLoading={isLoading || !data}
      illustration="nothing-to-see"
      emptyTableTitle={t('typography.noGroupsTitle')}
      emptyTableDescription={t('typography.noGroupsDescription')}
    >
      <Table>
        <TableBody>
          {data?.map(group => (
            <GroupsTableRow key={group.id} group={group} />
          ))}
        </TableBody>
      </Table>
    </TableProvider>
  )
}
